<div class="modal-body paywall-container">
    <div class="d-flex justify-content-between align-items-start gap-2">
        <button type="button" class="btn btn-help-header" (click)="helpButton()" title="Solicitar Ayuda">
            <i class="fas fa-circle-question me-2"></i> Ayuda
        </button>
        <div class="d-flex flex-column align-items-center w-100 gap-1">
            <div class="text-center mb-2">
                <img [src]="'/assets/system/logo_settings.png'" width="120px" class="logo-img">
            </div>

            <h2 *ngIf="!generarEnlace; else generarEnlaceTemplate" class="paywall-title">
                Seleccione el plan perfecto para su negocio
            </h2>
        </div>
        <button type="button" class="btn-close" aria-label="Close"
            (click)="activeModal.dismiss('Cross click')"></button>
    </div>


    <div class="period-toggle-container">
        <div class="period-toggle">
            <button type="button" class="period-option" [class.active]="periodo == 'MENSUAL'"
                (click)="seleccionarPeriodo('MENSUAL')">
                Mensual
            </button>
            <button type="button" class="period-option" [class.active]="periodo == 'ANUAL'"
                (click)="seleccionarPeriodo('ANUAL')">
                Anual
                <span class="save-badge" *ngIf="periodo == 'ANUAL'">Ahorra 2 meses</span>
            </button>
        </div>
    </div>

    <div class="plans-grid">
        <!-- Plan FILTRO X -->
        <div class="plan-card" [ngClass]="{
                'selected': plan == 'FILTRO_X', 
                'disabled': isDowngradeFiltroX, 
                'current-plan': planPrevioSeleccionado == 'FILTRO_X'
            }" (click)="seleccionarPlan('FILTRO_X')">

            <div class="plan-header">
                <h3 class="plan-name">FILTRO X</h3>
                <div class="plan-badge starter" *ngIf="planPrevioSeleccionado != 'FILTRO_X'">Básico</div>
                <div class="current-badge" *ngIf="planPrevioSeleccionado == 'FILTRO_X'">
                    <span>✓</span> Plan Actual
                </div>
            </div>

            <div class="price-section">
                <div class="price-main">
                    <span class="currency" [class.strikethrough]="montoFiltroXAlt">{{currency}}</span>
                    <span class="amount" [class.strikethrough]="montoFiltroXAlt">{{formatPrice(montoFiltroX)}}</span>
                </div>
                <div class="iva-text" *ngIf="esPaisChile">+ IVA</div>

                <div class="savings-badge" *ngIf="periodo == 'ANUAL' && planPrevioSeleccionado != 'FILTRO_X'">
                    <span class="savings-icon">🎉</span>
                    Ahorra {{currency}} {{formatPrice(montoAhorroFiltroXYear)}} + IVA
                    <div class="savings-subtitle">2 Meses Gratis</div>
                </div>

                <div class="promo-text" *ngIf="!planPrevio && periodo != 'ANUAL' && esPaisChile">
                    {{currency}} {{formatPrice(montoParcialFiltroX)}} el primer mes *
                </div>
            </div>

            <div class="features-section">
                <div class="feature-item">
                    <span class="feature-icon">✓</span>
                    <span>Ventas</span>
                </div>
                <div class="feature-item">
                    <span class="feature-icon">✓</span>
                    <span>Órdenes de Trabajo</span>
                </div>
                <div class="feature-item">
                    <span class="feature-icon">✓</span>
                    <span>Inventario</span>
                </div>
                <div class="feature-item">
                    <span class="feature-icon">✓</span>
                    <span>Soporte Personalizado</span>
                </div>
                <div class="feature-item user-count">
                    <span class="feature-icon">👤</span>
                    <span><strong>1 Usuario</strong></span>
                </div>
            </div>

            <div class="downgrade-text" *ngIf="planPrevio && isDowngradeFiltroX">
                ** Contáctese con su agente de ventas
            </div>
        </div>

        <!-- Plan ACELERA+ -->
        <div class="plan-card" [ngClass]="{
                'selected': plan == 'ACELERA', 
                'disabled': isDowngradeAcelera, 
                'current-plan': planPrevioSeleccionado == 'ACELERA'
            }" (click)="seleccionarPlan('ACELERA')">

            <div class="plan-header">
                <h3 class="plan-name">ACELERA+</h3>
                <div class="plan-badge professional" *ngIf="planPrevioSeleccionado != 'ACELERA'">Profesional</div>
                <div class="current-badge" *ngIf="planPrevioSeleccionado == 'ACELERA'">
                    <span>✓</span> Plan Actual
                </div>
            </div>

            <div class="price-section">
                <div class="price-main">
                    <span class="currency" [class.strikethrough]="montoAceleraAlt">{{currency}}</span>
                    <span class="amount" [class.strikethrough]="montoAceleraAlt">{{formatPrice(montoAcelera)}}</span>
                </div>
                <div class="iva-text" *ngIf="esPaisChile">+ IVA</div>

                <div class="savings-badge" *ngIf="periodo == 'ANUAL' && planPrevioSeleccionado != 'ACELERA'">
                    <span class="savings-icon">🎉</span>
                    Ahorra {{currency}} {{formatPrice(montoAhorroAceleraYear)}} + IVA
                    <div class="savings-subtitle">2 Meses Gratis</div>
                </div>

                <div class="promo-text" *ngIf="!planPrevio && periodo != 'ANUAL' && esPaisChile">
                    {{currency}} {{formatPrice(montoParcialAcelera)}} el primer mes *
                </div>
            </div>

            <div class="features-section">
                <div class="feature-item highlight">
                    <span class="feature-icon">⚡</span>
                    <span><strong>Todas las funciones de Filtro X</strong></span>
                </div>
                <div class="feature-item">
                    <span class="feature-icon">✓</span>
                    <span>Reportes</span>
                </div>
                <div class="feature-item">
                    <span class="feature-icon">✓</span>
                    <span>Clientes</span>
                </div>
                <div class="feature-item">
                    <span class="feature-icon">✓</span>
                    <span>Cobranza</span>
                </div>
                <div class="feature-item">
                    <span class="feature-icon">✓</span>
                    <span>Vehículos</span>
                </div>
                <div class="feature-item">
                    <span class="feature-icon">✓</span>
                    <span>Recepción de Vehículos</span>
                </div>
                <div class="feature-item">
                    <span class="feature-icon">✓</span>
                    <span>Item Checklists</span>
                </div>
                <div class="feature-item">
                    <span class="feature-icon">✓</span>
                    <span>Servicios</span>
                </div>
                <div class="feature-item">
                    <span class="feature-icon">✓</span>
                    <span>Cotizaciones</span>
                </div>
                <div class="feature-item">
                    <span class="feature-icon">✓</span>
                    <span>Plantillas OT</span>
                </div>
                <div class="feature-item">
                    <span class="feature-icon">✓</span>
                    <span>Soporte Personalizado</span>
                </div>
                <div class="feature-item user-count">
                    <span class="feature-icon">👥</span>
                    <span><strong>5 Usuarios</strong></span>
                </div>
            </div>

            <div class="downgrade-text" *ngIf="planPrevio && isDowngradeAcelera">
                ** Contáctese con su agente de ventas
            </div>
        </div>

        <!-- Plan TURBO -->
        <div class="plan-card popular" [ngClass]="{
                'selected': plan == 'TURBO', 
                'disabled': isDowngradeTurbo && planPrevioSeleccionado != 'TURBO', 
                'current-plan': planPrevioSeleccionado == 'TURBO'
            }" (click)="seleccionarPlan('TURBO')">

            <div class="popular-ribbon">MÁS POPULAR</div>

            <div class="plan-header">
                <h3 class="plan-name">TURBO</h3>
                <div class="plan-badge enterprise" *ngIf="planPrevioSeleccionado != 'TURBO'">Empresarial</div>
                <div class="current-badge" *ngIf="planPrevioSeleccionado == 'TURBO'">
                    <span>✓</span> Plan Actual
                </div>
            </div>

            <div class="price-section">
                <div class="price-main">
                    <span class="currency" [class.strikethrough]="montoTurboAlt">{{currency}}</span>
                    <span class="amount" [class.strikethrough]="montoTurboAlt">{{formatPrice(montoTurbo)}}</span>
                </div>
                <div class="iva-text" *ngIf="esPaisChile">+ IVA</div>

                <div class="savings-badge" *ngIf="periodo == 'ANUAL' && planPrevioSeleccionado != 'TURBO'">
                    <span class="savings-icon">🎉</span>
                    Ahorra {{currency}} {{formatPrice(montoAhorroTurboYear)}} + IVA
                    <div class="savings-subtitle">2 Meses Gratis</div>
                </div>

                <div class="promo-text" *ngIf="!planPrevio && periodo != 'ANUAL' && esPaisChile">
                    {{currency}} {{formatPrice(montoParcialTurbo)}} el primer mes *
                </div>
            </div>

            <div class="features-section">
                <div class="feature-item highlight">
                    <span class="feature-icon">⚡</span>
                    <span><strong>Todas las funciones de Acelera+</strong></span>
                </div>
                <div class="feature-item">
                    <span class="feature-icon">✓</span>
                    <span>Gastos</span>
                </div>
                <div class="feature-item">
                    <span class="feature-icon">✓</span>
                    <span>Orden de Compras</span>
                </div>
                <div class="feature-item">
                    <span class="feature-icon">✓</span>
                    <span>Compras</span>
                </div>
                <div class="feature-item">
                    <span class="feature-icon">✓</span>
                    <span>Caja</span>
                </div>
                <div class="feature-item">
                    <span class="feature-icon">✓</span>
                    <span>Proveedores</span>
                </div>
                <div class="feature-item">
                    <span class="feature-icon">✓</span>
                    <span>Anuncios Publicitarios</span>
                </div>
                <div class="feature-item">
                    <span class="feature-icon">✓</span>
                    <span>App Móvil para sus clientes</span>
                </div>
                <div class="feature-item">
                    <span class="feature-icon">✓</span>
                    <span>Citas</span>
                </div>
                <div class="feature-item">
                    <span class="feature-icon">✓</span>
                    <span>Certificado de Mantenimiento</span>
                </div>
                <div class="feature-item">
                    <span class="feature-icon">✓</span>
                    <span>Soporte Personalizado</span>
                </div>
                <div class="feature-item user-count">
                    <span class="feature-icon">👥</span>
                    <span><strong>12 Usuarios</strong></span>
                </div>
            </div>

            <div class="downgrade-text" *ngIf="planPrevio && isDowngradeTurbo">
                ** Contáctese con su agente de ventas
            </div>
        </div>
    </div>
</div>
<div class="modal-footer border-0 bg-light">
    <form [formGroup]="form" class="w-100">
        <div class="disclaimer-section">
            <p class="disclaimer-text" *ngIf="!planPrevio && periodo != 'ANUAL' && esPaisChile">
                (*) El primer mes se realizará un cobro proporcional por los días hasta el primer día del próximo mes
                ({{dias}} día{{dias == 1 ? '' : 's'}}).
            </p>
            <p class="disclaimer-text" *ngIf="planPrevio && esPaisChile">
                (*) Valor por el primer mes. Luego se cobrará tarifa mensual regular indicada por el plan suscrito.
            </p>
            <p class="disclaimer-text" *ngIf="planPrevio && esPaisChile">
                (**) Para cambiar de plan a uno inferior, por favor contactar con su agente de ventas.
            </p>
            <p class="disclaimer-text" *ngIf="planPrevio && !esPaisChile">
                (*) Para cambiar de plan, por favor contactar con su agente de ventas.
            </p>
        </div>
        <div class="referral-section">
            <label class="referral-label">
                <span class="referral-icon">🎁</span>
                ¿Tiene un código de referido?
            </label>
            <input type="text" formControlName="codigo_referido" class="form-control referral-input"
                placeholder="Código de referido" />
        </div>

        <button class="btn btn-cta" [disabled]="!plan" type="button" (click)="continueButton()">
            {{textoSubmitButton}}
        </button>
    </form>
</div>

<ng-template #generarEnlaceTemplate>
    <h4 class="d-flex justify-content-center mb-4" style="text-align: center; font-size: 16px;">
        Seleccione un plan para generar el enlace de suscripción.
    </h4>
</ng-template>